import React, { forwardRef, useEffect, useState } from 'react'
import moment from 'moment'
import * as ReactBootstrap from 'react-bootstrap'
import momentLocalizer from 'react-widgets-moment'
import DatePicker from 'react-datepicker'
import setHours from 'date-fns/setHours'
import setMinutes from 'date-fns/setMinutes'
import { getMonth, getYear } from 'date-fns'

new momentLocalizer(moment)

const calculateHolidays = (holidays) => {
  const isWeekday = (date) => {

    const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1)
      .toString()
      .padStart(2, '0')}-${date.getDate()}`
    const is_holiday = holidays && holidays.includes(formattedDate)
    // return day !== 0 && !is_holiday
    return !is_holiday
  }
  return isWeekday
}

const CustomDateTimePicker = ({
  onChange,
  holidays,
  minDate,
  disabled,
  dateFormat,
  value
}) => {
  const [selectedValue, setSelectedValue] = useState(value ? new Date(value) : null)
  useEffect(() => {

    value && setSelectedValue(new Date(value))
  }, [value])
  const currentYear = getYear(new Date())
  const years = Array.from({ length: 20 }, (_, i) => currentYear - 5 + i)
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ]
  const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => {

    return (
      <ReactBootstrap.Form.Group className={'mt-3 mb-3 pt-2'}>
        <input
          ref={ref}
          disabled={disabled}
          defaultValue={value}
          className="form-control"
          onClick={onClick}
        />
      </ReactBootstrap.Form.Group>
    )
  })

  return (
    <DatePicker
      showTimeSelect={true}
      selected={selectedValue}
      onChange={(x) => {
        onChange(x)
        setSelectedValue(x)
      }}
      renderCustomHeader={({
        date,
        changeYear,
        changeMonth,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
      }) => (
        <div
          style={{
            margin: 10,
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <button type="button" onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
            {'<'}
          </button>
          <select
            value={getYear(date)}
            onChange={({ target: { value } }) => changeYear(value)}
          >
            {years.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>

          <select
            value={months[getMonth(date)]}
            onChange={({ target: { value } }) =>
              changeMonth(months.indexOf(value))
            }
          >
            {months.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>

          <button type="button" onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
            {'>'}
          </button>
        </div>
      )}
      customInput={<ExampleCustomInput value={value} />}
      disabled={disabled}
      minDate={minDate}
      timeFormat="HH:mm"
      timeIntervals={15}
      minTime={setHours(setMinutes(new Date(), 0), 10)}
      maxTime={setHours(setMinutes(new Date(), 0), 20)}
      filterDate={calculateHolidays(holidays)}
      timeCaption="time"
      dateFormat={dateFormat}
    />
  )
}

export const renderDateTimePicker = ({
  input: { onChange, value, name },
  label,
  holidays,
  disabled,
  dateFormat,
  minDate,
}) => {
  return (
    <>
      <label>{label}</label>
      <CustomDateTimePicker
        disabled={disabled}
        label={label}
        value={value}
        dateFormat={dateFormat}
        minDate={minDate}
        onChange={onChange}
        holidays={holidays}
      />
    </>
  )
}
